export const AuditTrailModuleTranslations: Array<string> = [
    // title
    'xmlAuditTrail',
    'xmlChangeSet',
    'Admin.ChangeSet.CreateNew',

    // audit trail
    'Admin.AuditTrail.AdminAction',
    'Admin.AuditTrail.UserAction',
    'Admin.AuditTrail.Products',
    'Admin.AuditTrail.Attributes',
    'Admin.AuditTrail.Pricebooks',
    'Admin.AuditTrail.CustomTable',
    'Admin.UserActionAuditTrail_ChangeSetId',
    'Admin.UserActionAuditTrail_ChangeStep',
    'Admin.AuditTrail.GlobalFilters',

    // user action audit trail
    'Admin.UserActionAuditTrail_Quote',
    'Admin.UserActionAuditTrail_QuoteRevision',
    'Admin.UserActionAuditTrail_QuoteStatus',
    'Admin.UserActionAuditTrail_QuoteItem',
    'Admin.UserActionAuditTrail_PRODUCT',
    'Admin.UserActionAuditTrail_ATTRIBUTE',
    'Admin.UserActionAuditTrail_ACTION',
    'Admin.UserActionAuditTrail_FIELD',
    'Admin.UserActionAuditTrail_PREVIOUS_VALUE',
    'Admin.UserActionAuditTrail_NEW_VALUE',
    'Admin.UserActionAuditTrail_Page',
    'Admin.AuditTrail.UserActionQuickSearch',
    'Admin.AuditTrail.TotalRecords',
    'Admin.appParams.LabelDisablePricebookAuditTrail.Warning.AuditDisabled',


  // admin action audit trail
    'Admin.AuditTrail.AdminActionQuickSearch',
    'Admin.UserActionAuditTrail_ENTITY',
    'Admin.UserActionAuditTrail_ENTITY_ID',
    'Admin.QuoteMigration.DownloadExcel',

    // product action audit trail
    'Admin.AuditTrail.ProductActionQuickSearch',
    'Admin.ProductAuditTrail_PRODUCT',
    'Admin.ProductAuditTrail_PRODUCT_SYSTEM_ID',
    'Admin.ProductAuditTrail_ATTRIBUTE',
    'Admin.ProductAuditTrail_ATTRIBUTE_SYSTEM_ID',
    'Admin.ProductAuditTrail_ATTRIBUTE_VALUE',
    'Admin.ProductAuditTrail_RULE_MESSAGE',
    'Admin.ProductAuditTrail_FIELD',
    'Admin.ProductAuditTrail_ACTION',
    'Admin.ProductAuditTrail_PREVIOUS_VALUE',
    'Admin.ProductAuditTrail_NEW_VALUE',
    'Admin.CopyToClipboard',

    // pricebook audit trail
    'Admin.AuditTrail.PricebookActionQuickSearch',
    'Admin.Pricebooks.Pricebook',
    'Admin.Pricebooks.PartNumber',
    'Admin.AuditTrail.Pricebooks.PartNumber',
    'Admin.Pricebooks.Entries.PriceCode',

    // custom table action audit trail
    'Admin.AuditTrail.CustomTableActionQuickSearch',
    'Admin.UserActionAuditTrail_ENTITY',
    'Admin.UserActionAuditTrail_ENTITY_ID',

    // attribute table action audit trail
    'Admin.AuditTrail.AttributeActionQuickSearch',

    // change set datatable
    'Admin.ChangeSet.Deploy',
    'Admin.ChangeSet.NewChangeSet',
    'Admin.SideMenu.AddNewChangeSet',
    'Admin.ChangeSet.Active',
    'Admin.ChangeSet.Name',
    'Admin.ChangeSet.Description',
    'Admin.ChangeSet.ChangeSetId',
    'Admin.ChangeSet.Date',
    'Admin.ChangeSet.User',
    'Admin.ChangeSet.Search',

    // deploy change sets
    'Admin.AuditTrail.DeployChangeSets',
    'Admin.Msg.ConnectedEnvironments',
    'Actions.ChangeSet.SendDeploySuccess',
    'Actions.ChangeSet.NoConnectedEnvMsg',
    'Admin.DeployChangeSets.QuickSearch',
    'Admin.DeployChangeSets.TargetEnvironment',

    //Parameters action audit trail
    'Admin.AuditTrail.Parameters',
    'Admin.ParametersActionAuditTrail.ReasonOfChange',
    'Admin.AuditTrail.ParametersActionQuickSearch'
];
